import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V2 } from '../../../src/common/constants';

const URL = `${BASE_URL_V2}${API.endpoints.tour}/:tourId${API.endpoints.sendToOptimizer}`;

const sendToOptimizerSuccessResponse = http.post(URL, () => {
    return new HttpResponse(null, { status: 204 });
});

const sendToOptimizerErrorResponse = http.post(URL, () => {
    return HttpResponse.error();
});

export const sendToOptimizerResponse = {
    success: sendToOptimizerSuccessResponse,
    error: sendToOptimizerErrorResponse,
};
